import React from 'react';
import PropTypes from 'prop-types';
import ConsultantTalentCard from './ConsultantTalentCard';
import emptyTalentPageGraphic from '../../../assets/images/empty_my_talent_graphic.png';
function ConsultantTalentContainer(_ref) {
  var talent = _ref.talent;
  if (talent.length === 0) {
    // no talent to display
    return /*#__PURE__*/React.createElement("div", {
      className: "empty-consultant-talent-container style-guide d-flex justify-content-center align-items-center flex-column"
    }, /*#__PURE__*/React.createElement("p", {
      className: "normal-weight"
    }, "Access your consultants' information here."), /*#__PURE__*/React.createElement("p", {
      className: "normal-weight"
    }, "Once you begin working with a consultant, they will appear on this page."), /*#__PURE__*/React.createElement("img", {
      src: emptyTalentPageGraphic,
      className: "empty-talent-graphic mt-5",
      alt: "Scientist Graphic"
    }));
  }
  return /*#__PURE__*/React.createElement("div", {
    className: "consultant-talent-container"
  }, talent.map(function (consultant) {
    return /*#__PURE__*/React.createElement(ConsultantTalentCard, {
      key: consultant.id,
      id: consultant.resource_id,
      consultant: consultant
    });
  }));
}
ConsultantTalentContainer.propTypes = {
  talent: PropTypes.arrayOf(PropTypes.shape({})).isRequired
};
export default ConsultantTalentContainer;